import{format as r,parseISO as t}from"date-fns";var e=function(e){if(!e)return"";try{return r(t(e),"MM/dd/yyyy")}catch(r){return console.error(r),""}};export{e as formatDate};
